exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.drag_picker__wrapper--6dcI7 {\r\n\twidth: 130px;\r\n\theight: 130px;\r\n\tposition: relative\r\n}\n\n.drag_picker__wrapper--6dcI7 .drag_picker__text--2MtOx {\r\n\t\twidth: 77px;\r\n\t\tcolor: #5b6d79;\r\n\t\tfont-family: 'avenirroman', Helvetica, Arial, sans-serif;\r\n\t\tfont-size: 12px;\r\n\t\tline-height: 13px;\r\n\t\tmargin: 0 auto;\r\n\t\ttext-align: center;\r\n\t\tposition: absolute;\r\n\t\ttop: 29px;\r\n\t\tright: 0;\r\n\t\tleft: 0;\r\n\t}\r\n", ""]);

// exports
exports.locals = {
	"wrapper": "drag_picker__wrapper--6dcI7",
	"text": "drag_picker__text--2MtOx"
};